import uniqueId from 'lodash/uniqueId';
import BaseModel from '../../../../../base';

export default class TournamentStageGroupDopScoreItem extends BaseModel {
  constructor(item = {}, url = 'tournament-stage-group-dop-score-items') {
    super(item, url);

    this.key = item.id ?? item.key ?? uniqueId('tournament-dop-score-item-');
    this.tournament_stage_group_dop_score_id = item.tournament_stage_group_dop_score_id ?? null;
    this.name = item.name || '';
    this.order = Number(item.order ?? 0);
    this.max_score = item.max_score == null ? null : Number(item.max_score);
    this.created_at = item.created_at;
  }

  toForm() {
    return {
      id: this.isServer ? this.id : null,
      key: this.key,
      name: this.name,
      order: this.order,
      max_score: this.max_score,
    };
  }

  toSyncPayload() {
    return {
      ...(this.isServer ? { id: this.id } : {}),
      name: this.name.trim(),
      max_score: this.max_score,
    };
  }
}
